import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
  Navigate,
} from "react-router-dom";
import Transaction from "./components/Transaction/Transaction";
import Payout from "./components/Payload/Payout";
import Statement from "./components/Statement/Statement";
import Layout from "./components/Layout/Layout";
import CreateContact from "./components/Contact/CreateContact";
import ContactList from "./components/ContactList/ContactList";
import PayoutView from "./components/PayoutView/PayoutView";
import Report from "./components/Report/Report";
import Beneficiary from "./components/Beneficiary/Beneficiary";
import UserMgmt from "./UserMgmt/UserMgmt";
import EscrowManagement from "./components/EscrowManagement/EscrowManagement";
import SubEscrow from "./components/SubEscrow/SubEscrow";
import Login from "./components/Login/Login";
import EscrowView from "./components/EscrowManagement/EscrowView/EscrowView";
import BulkPayout from "./components/Payload/BulkPayout";
import GetEscrowDetails from "./components/EscrowManagement/GetEscrowDetails/GetEscrowDetails";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/transaction":
        title = "Digital Escrow";
        metaDescription = "Welcome to the home page";
        break;
      // Add other cases if needed
    }

    if (title) document.title = title;
    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) metaDescriptionTag.content = metaDescription;
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route element={<Layout />}>
        <Route path="/escrow-management" element={<EscrowManagement />} />
        <Route
          path="/escrow-management/add-escrow"
          element={<GetEscrowDetails />}
        />
        <Route
          path="/escrow-management/:main_escrow_id"
          element={<EscrowView />}
        />
        <Route path="/transaction" element={<Transaction />} />
        <Route path="/payout" element={<Payout />} />
        <Route path="/payout/bulkpayout" element={<BulkPayout />} />
        <Route path="/payout-view" element={<PayoutView />} />
        <Route path="/statement" element={<Statement />} />
        <Route path="/report" element={<Report />} />
        <Route path="/beneficiary" element={<Beneficiary />} />
        <Route path="/user-management" element={<UserMgmt />} />
        <Route path="/user-management/:id" element={<UserMgmt />} />
        <Route path="/sub-escrow" element={<SubEscrow />} />
        {/* <Route path="/contact" element={<ContactList />} /> */}
        {/* <Route path="/createcontact" element={<CreateContact />} /> */}
      </Route>
    </Routes>
  );
}

export default App;
